import { StartDateRange } from './startdaterange';

export class Filter {
  public radius: number = 0;
  public companyCode: string = '';
  public minJobPay: number = 0.0;
  public jobPayUOM: string = '';
  public jobTypes: string[] = [];
  public industryTypes: number[] = [];
  public skillTypes: number[] = [];
  public jobTags: string = '';
  public matchAvailability: boolean = false;
  public matchMySkills: boolean = false;
  public datePosted: string = '';
  public candidatePlacementTypes: string[] = [];
  public shiftTypes: number[] = [];
  public categoryIds: number[] = [];
  public facilityId: number = 0;
  public customFields: any = {};
  public remoteJobType: string[] = [];
}
